import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { href: "#chi-sono", label: "Chi Sono" },
  { href: "#approccio", label: "Approccio" },
  { href: "#competenze", label: "Competenze" },
  { href: "#sedi", label: "Sedi" },
  { href: "#faq", label: "FAQ" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/85 backdrop-blur-xl border-b border-stone-200"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16 h-16 md:h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-baseline gap-2 group"
        >
          <span className="font-display text-base md:text-lg font-medium tracking-tight text-stone-900">
            Dr.ssa Silvia Dal Bello
          </span>
          <span className="hidden md:inline text-[11px] uppercase tracking-[0.22em] text-stone-500">
            Medico Radiologo
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm text-stone-700 hover:text-[#3E615B] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <Button
            asChild
            data-testid="nav-cta-prenota"
            className="rounded-full bg-[#3E615B] hover:bg-[#2D4742] text-white px-6"
          >
            <a href="#contatti">Prenota</a>
          </Button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 rounded-full hover:bg-stone-100"
          onClick={() => setOpen(!open)}
          aria-label="Apri menu"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden bg-white border-t border-stone-200"
        >
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                onClick={() => setOpen(false)}
                className="text-sm text-stone-700"
              >
                {l.label}
              </a>
            ))}
            <Button
              asChild
              data-testid="nav-mobile-cta"
              className="rounded-full bg-[#3E615B] hover:bg-[#2D4742] text-white"
            >
              <a href="#contatti" onClick={() => setOpen(false)}>
                Prenota
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
